import { ViewRecords } from '@aibees/elephant/components/view-records';
import { BREADCRUMBS_CONFIG } from '@aibees/elephant/constants';
import { useSidebarOptions } from '@aibees/elephant/constants/dashboard-sidebar-config';
import { useAccountMenuConfig } from '@aibees/elephant/hooks';
import { useAccountMenuOptions } from '@aibees/elephant/hooks/use-account-menu-options';
import { ROUTES } from '@aibees/elephant/router';
import { HeaderBreadcrumbs } from '@aibees/shared/components';
import { SettingLayout as BaseSettingLayout } from '@aibees/shared/layouts';
import { useTheme } from '@mui/material/styles';
import { PropsWithChildren } from 'react';

export default function SettingLayout({ children }: PropsWithChildren) {
  const accountMenuOptions = useAccountMenuOptions();
  const theme = useTheme();
  const { ACCOUNT_SETTING_MENU_OPTIONS } = useAccountMenuConfig();
  const sidebarItems = useSidebarOptions();

  return (
    <BaseSettingLayout
      options={{
        header: {
          accountMenu: accountMenuOptions,
          breadcrumb: (
            <HeaderBreadcrumbs
              config={{ titles: BREADCRUMBS_CONFIG, routes: ROUTES }}
            />
          ),
          hideNavVertical: true,
          topRightSlot: <ViewRecords />,
        },
        sidebar: sidebarItems,
        navigation: {
          data: ACCOUNT_SETTING_MENU_OPTIONS,
          config: {
            searchable: true,
            itemPadding: theme.spacing(0, 1),
            itemMargin: theme.spacing(0, 1.5),
            itemRootHeight: 44,
          },
        },
      }}
    >
      {children}
    </BaseSettingLayout>
  );
}
